module.exports = __webpack_public_path__ + "img/threeBirds.3bfd5dc6.png";